module.exports = __webpack_public_path__ + "static/media/second.7f4cae36.svg";